import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export interface DocumentSend {
  id: string;
  document_type: 'estimate' | 'invoice' | 'change_order';
  document_id: string;
  version_id: string | null;
  resend_email_id: string | null;
  recipient_email: string;
  recipient_name: string | null;
  subject: string;
  body_html: string | null;
  sent_by: string | null;
  sent_at: string;
  status: 'sent' | 'delivered' | 'opened' | 'clicked' | 'bounced' | 'failed' | 'complained';
  delivered_at: string | null;
  opened_at: string | null;
  open_count: number;
  clicked_at: string | null;
  click_count: number;
  bounced_at: string | null;
  bounce_reason: string | null;
  failed_at: string | null;
  error_message: string | null;
  company_id: string;
  created_at: string;
}

export const useDocumentSends = (documentType: 'estimate' | 'invoice' | 'change_order', documentId: string) => {
  return useQuery({
    queryKey: ['document-sends', documentType, documentId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('document_sends')
        .select('*')
        .eq('document_type', documentType)
        .eq('document_id', documentId)
        .order('sent_at', { ascending: false });

      if (error) throw error;
      return data as DocumentSend[];
    },
    enabled: !!documentId,
  });
};

export const useLatestDocumentSend = (documentType: 'estimate' | 'invoice' | 'change_order', documentId: string) => {
  return useQuery({
    queryKey: ['document-sends', documentType, documentId, 'latest'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('document_sends')
        .select('*')
        .eq('document_type', documentType)
        .eq('document_id', documentId)
        .order('sent_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error) throw error;
      return data as DocumentSend | null;
    },
    enabled: !!documentId,
  });
};
